<template>
  <ContentWrap>
    <el-form :model="query" inline>
      <el-form-item label="分类名称"
        ><el-input v-model="query.categoryName" clearable
      /></el-form-item>
      <el-form-item label="分类编码"
        ><el-input v-model="query.categoryCode" clearable
      /></el-form-item>
      <el-form-item label="类型">
        <el-select v-model="query.categoryType" clearable class="!w-120px">
          <el-option label="行业" :value="1" /><el-option label="工种" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable class="!w-120px">
          <el-option label="启用" :value="1" /><el-option label="禁用" :value="0" />
        </el-select>
      </el-form-item>
      <el-button type="primary" @click="search">查询</el-button>
      <el-button v-hasPermi="['bosscircle:circle-category:create']" @click="openForm()"
        >新增</el-button
      >
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column prop="categoryName" label="分类名称" min-width="160" />
      <el-table-column prop="categoryCode" label="分类编码" min-width="150" />
      <el-table-column label="类型" width="100">
        <template #default="scope">{{ scope.row.categoryType === 1 ? '行业' : '工种' }}</template>
      </el-table-column>
      <el-table-column prop="sortOrder" label="排序" width="90" />
      <el-table-column label="状态" width="90">
        <template #default="scope">{{ scope.row.status === 1 ? '启用' : '禁用' }}</template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template #default="scope">
          <el-button
            v-hasPermi="['bosscircle:circle-category:update']"
            link
            type="primary"
            @click="openForm(scope.row)"
            >修改</el-button
          >
          <el-button
            v-hasPermi="['bosscircle:circle-category:delete']"
            link
            type="danger"
            @click="remove(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog v-model="formVisible" :title="form.id ? '修改商圈分类' : '新增商圈分类'" width="520px">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="90px">
      <el-form-item label="分类名称" prop="categoryName"
        ><el-input v-model="form.categoryName" maxlength="100"
      /></el-form-item>
      <el-form-item label="分类编码" prop="categoryCode"
        ><el-input v-model="form.categoryCode" maxlength="64"
      /></el-form-item>
      <el-form-item label="类型" prop="categoryType">
        <el-radio-group v-model="form.categoryType"
          ><el-radio :value="1">行业</el-radio><el-radio :value="2">工种</el-radio></el-radio-group
        >
      </el-form-item>
      <el-form-item label="排序" prop="sortOrder"
        ><el-input-number v-model="form.sortOrder" :min="0"
      /></el-form-item>
      <el-form-item label="状态" prop="status"
        ><el-radio-group v-model="form.status"
          ><el-radio :value="1">启用</el-radio><el-radio :value="0">禁用</el-radio></el-radio-group
        ></el-form-item
      >
    </el-form>
    <template #footer
      ><el-button @click="formVisible = false">取消</el-button
      ><el-button type="primary" @click="submit">保存</el-button></template
    >
  </Dialog>
</template>

<script setup lang="ts">
import * as CategoryApi from '@/api/business/circleCategory'

defineOptions({ name: 'BossCircleCircleCategory' })
const message = useMessage()
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const formVisible = ref(false)
const formRef = ref()
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  categoryName: '',
  categoryCode: '',
  categoryType: undefined,
  status: undefined
})
const form = reactive<any>({
  id: undefined,
  categoryName: '',
  categoryCode: '',
  categoryType: 1,
  sortOrder: 0,
  status: 1,
  version: undefined
})
const rules = {
  categoryName: [{ required: true, message: '请输入分类名称' }],
  categoryCode: [{ required: true, message: '请输入分类编码' }]
}
const load = async () => {
  loading.value = true
  try {
    const data = await CategoryApi.getCircleCategoryPage(query)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const search = () => {
  query.pageNo = 1
  load()
}
const openForm = (row?: any) => {
  Object.assign(
    form,
    row || {
      id: undefined,
      categoryName: '',
      categoryCode: '',
      categoryType: 1,
      sortOrder: 0,
      status: 1,
      version: undefined
    }
  )
  formVisible.value = true
}
const submit = async () => {
  await formRef.value.validate()
  if (form.id) await CategoryApi.updateCircleCategory(form)
  else await CategoryApi.createCircleCategory(form)
  message.success('保存成功')
  formVisible.value = false
  await load()
}
const remove = async (row: any) => {
  await message.delConfirm()
  await CategoryApi.deleteCircleCategory({ id: row.id, version: row.version })
  message.success('删除成功')
  await load()
}
onMounted(load)
</script>
